import { NgModule } from "@angular/core";
import { UiRadioGroupComponent } from "./components/radio-group/radio-group.component";
import { UiRadioButtonDirective } from "./directives/radio-button.directive";
import { UiRadioComponent } from "./radio.component";

@NgModule({
  imports: [UiRadioComponent, UiRadioButtonDirective, UiRadioGroupComponent],
  exports: [UiRadioComponent, UiRadioButtonDirective, UiRadioGroupComponent],
})
export class UiRadioModule {}
